<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:29:10
 * @Description: 罐区仓库需求列表页面，状态：待发布、已发布。
 -->
<template>
  <div class="content-container">
    <div class="demand-head">
      <div class="slider-list">
        <div :class="{ 'selected': state == '1'}" class="item" @click="toggleState('1')">待发布</div>
        <div :class="{ 'selected': state == '2'}" class="item" @click="toggleState('2')">已发布</div>
        <div :class="{ 'selected': state == '3'}" class="item" @click="toggleState('3')">已成交</div>
      </div>
      <!-- 查询表单  -->
      <div class="demand-head-form">
        <div class="fileds">
          <el-form ref="form" :model="queryParams" :inline="true">
            <div class="demand-condition">
              <el-form-item label="租单名称:" prop="demandName">
                <el-input v-model.trim="queryParams.demandName" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="储存品类:" prop="storageType">
                <el-select v-model="queryParams.storageType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in storageType.tankType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="罐区容积:" prop="goodsStartCubage">
                <div class="demand-area">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="goodsStartCubage">
                        <el-input v-model.number="queryParams.goodsStartCubage" placeholder="请输入" @change="startChange" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <span>至</span>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item prop="goodsEndCubage">
                        <el-input v-model.number="queryParams.goodsEndCubage" placeholder="请输入" @change="endChange" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="库房位置:" prop="storageLocation">
                <el-cascader
                  v-model="queryParams.storageLocation"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover' ,
                            checkStrictly: true}"
                  style="width: 100%;"
                  @expand-change="expandChange"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!--存入表格数据-->
    <article class="operations">
      <el-button
        v-if="state == '1'"
        size="small"
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="publishdemand('2')"
      >
        <i class="el-icon-plus" />发布
      </el-button>
      <el-button
        v-if="state == '1'"
        size="small "
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="batchDel"
      >
        <i class="el-icon-delete-solid" />批量删除
      </el-button>
    </article>
    <!-- 'tankDemand-data' :state == '2' , -->
    <div :class="{ 'tankDemand-data' :state == '2','demand-data' : state == '1','orderDemand-data' : state == '3' }">
      <div class="demand-data-header">
        <ul>
          <li v-if="state == '1'">
            <el-checkbox v-model="allSelection" type="checkbox" @change="selection()" />
          </li>
          <li>租单名称</li>
          <li>储存品类</li>
          <li>库房位置</li>
          <li>罐区容积</li>
          <li>期望租金</li>
          <!-- <li v-if="state =='2'">邀请企业</li> -->
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" v-loading="viewManager.loading" class="demand-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(demand, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li v-if="state == '1'">
                <el-checkbox v-model="demand.selection" type="checkbox" @change="change()" />
              </li>
              <el-tooltip class="item" effect="dark" :content="demand.demandName" placement="top">
                <li>{{ demand.demandName }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="demand.tankTypeLabel" placement="top">
                <li>{{ demand.tankTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="demand.storageLocationLabel" placement="top">
                <li>{{ demand.storageLocationLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${demand.goodsCubage}m³`" placement="top">
                <li>{{ demand.goodsCubage }}m³</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${demand.expectPrice}元/罐·天`" placement="top">
                <li>{{ demand.expectPrice }}元/罐/天</li>
              </el-tooltip>
              <!-- <el-tooltip v-if="state == '2'" class="item" effect="dark" :content="JSON.stringify(demand.inviteUser)" placement="top">
                <li><el-button type="text" @click="inviteClick(demand)">{{ demand.inviteUser }}</el-button></li>
              </el-tooltip> -->
              <li>
                <el-button v-if="state == '2'" type="text" @click="popRecommendList(demand)">仓库推荐</el-button>
                <el-divider v-if="state =='2'" direction="vertical" />
                <el-button v-if="state == '2' && demand.inviteUser < 1" type="text" @click="publishGetDemand('1',demand)">取消发布</el-button>
                <el-button v-if="state == '1'" type="text" @click="edit(demand)">编辑</el-button>
                <el-divider v-if="state == '1'" direction="vertical" />
                <el-button v-if="state == '1'" type="text" @click="publishGetDemand('2',demand)">立即发布</el-button>
                <el-button v-if="state == '1'" style="color: #be2316 !important;" type="text" @click="del(demand.id)">删除</el-button>
                <el-divider v-if="state =='1'" direction="vertical" />
                <el-button plain size="small" style="color: #be2316 !important;" @click="demandInfo(demand)">
                  详情
                  <i :class="{'expand': !demand.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <tankDemandInfo v-if="!demand.hidden" :demand="demand" />
          </div>
        </template>
      </div>
      <div class="demand-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="invitationManager.visible"
      title="编辑"
      width="80%"
      @click="invitationManager.close"
    >
      <el-form
        ref="tankFarmDemand"
        :rules="tankFarmDemandRules"
        :model="tankFarmDemand"
        :label-position="'right'"
        label-width="120px"
        style="padding-left: 0rem;padding-right: 2rem;"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="租单名称" prop="demandName">
              <el-input v-model="tankFarmDemand.demandName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="储存品类" prop="storageType">
              <el-checkbox-group v-model="tankFarmDemand.storageType">
                <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="预租时间" prop="leaseStartTime">
              <el-date-picker
                v-model="tankdatepicker"
                type="daterange"
                :editable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width:100%"
                @change="tankDateSet"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望价格" prop="expectPrice">
              <el-input v-model="tankFarmDemand.expectPrice">
                <template slot="append">元/罐/天</template>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="预租时间" prop="leaseStartTime">
              <el-date-picker :editable="false" v-model="tankFarmDemand.leaseStartTime" type="date" placeholder="选择日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <span style="position: absolute;margin-left: 2rem;margin-top: 0.3rem;">———</span>
            <el-form-item prop="leaseEndTime">
              <el-date-picker :editable="false" v-model="tankFarmDemand.leaseEndTime" type="date" placeholder="选择日期" style="width: 100%;" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="货物容积" prop="goodsCubage">
              <el-input v-model="tankFarmDemand.goodsCubage">
                <template slot="append">m³</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库房位置" prop="storageLocation">
              <el-cascader
                v-model="tankFarmDemand.storageLocation"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover' ,
                          checkStrictly: true}"
                style="width: 100%;"
                @expand-change="expandChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="消防资质" prop="fireQualification">
              <el-select v-model="tankFarmDemand.fireQualification" placeholder="请选择">
                <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
              <el-select v-model="tankFarmDemand.fireResistanceRating" placeholder="请选择消防资质">
                <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="货物图片" prop="cargoUrl">
              <g-upload :max-size="1" :limit="6" is-edit :multiple="true" :method-name="tankDemandFile" :img-list.sync="tankFarmDemand.cargoUrl" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="tankFarmDemand.companyName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="联系人" prop="linkMan">
              <el-input v-model="tankFarmDemand.linkMan" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="telephone">
              <el-input v-model="tankFarmDemand.telephone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注" prop="remarks">
              <el-input v-model="tankFarmDemand.remarks" type="textarea" :rows="6" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="">
              <span style="color: #be2316;">注：</span>
              <span>*均为必填项</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button type="danger" plain size="small" @click="tankFarmDemandEdit('tankFarmDemand')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <warehouseSuggest warehousing-type="2" :invitation-form="warehouseSuggestData" :invitation-manager="recommendManager.visible" @close="recommendManager.close" />
    <warehouseCompany warehousing-type="2" ware-ord-inv-type="invite" title-name="邀请企业信息" warehouse-type="demand" :company-form="companyManager.data" :company-manager="companyManager.visible" @close="companyManager.close" />
  </div>
</template>

<script>
import tankDemandInfo from './components/tankDemandInfo'
import warehouseSuggest from '../components/warehouseSuggest'
import warehouseCompany from '../components/warehouseCompany'
import { findPageDemand, getArea, demandRemove, delBatch, demandEdit, getDict, issueBatch } from '@/api/personal/store/tank-demand-list/tankDemand'
import { tableClass } from '@/api/personal/store/tank-demand-list/TankDemandParam'
import { isValidArray } from '@/utils/utilsMethods'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
const table = tableClass.getTable() // 引用表格参数类
import { tankFarmDemandRules } from '../dataConfig/rules'

const requiredItems = () => {
  const keys = []
  for (const key in tankFarmDemandRules) {
    if (tankFarmDemandRules[key].some(item => item.required)) {
      keys.push(key)
    }
  }
  return keys
}

const validateData = (item) => {
  for (const key in item) {
    if (requiredItems().some(i => i === key)) {
      if (!item[key]) {
        return { state: false, key: key }
      } else if (typeof item[key] === 'string' && item[key] === '') {
        return { state: false, key: key }
      } else if (Object.prototype.toString.call(item[key]) === 'Array' && item[key].length == 0) {
        return { state: false, key: key }
      }
    }
  }
}

export default {
  name: 'TankDemandList',
  components: {
    tankDemandInfo,
    warehouseSuggest,
    warehouseCompany
  },
  data: function() {
    // 期望租金校验方法
    var expectPrice = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入期望租金'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (value != 0 && number.reg.test(value)) {
            callback()
          } else {
            callback(new Error(number.title))
          }
        }
      }
    }
    // 货物容积校验方法
    var goodsCubage = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入货物容积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (value != 0 && number.reg.test(value)) {
            callback()
          } else {
            callback(new Error(number.title))
          }
        }
      }
    }
    return {
      invitationManager: {
        visible: false,
        close: () => {
          this.invitationManager.visible = false
        }
      },
      recommendManager: {
        visible: false,
        close: () => {
          this.loadData()
          this.recommendManager.visible = false
        }
      },
      companyManager: {
        visible: false,
        data: null,
        close: () => {
          this.companyManager.visible = false
        }
      },
      data: [],
      area: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      allSelection: false,
      warehouseSuggestData: {},
      tankdatepicker: null,
      storageType: {
        storageType: [],
        fireQualification: [],
        fireResistanceRating: [],
        tankType: []
      },
      // 表格数据
      pagination: table.Page,
      queryParams: {
        demandName: null,
        storageType: null,
        goodsStartCubage: null,
        goodsEndCubage: null,
        storageLocation: null
      },
      state: '1',
      viewManager: {
        loading: true
      },
      tankDemandFile: 'cangchuFile',
      tankFarmDemand: {
        demandName: null, // 需求名称
        storageType: [], // 储存类型
        leaseStartTime: null, // 租赁开始日期
        leaseEndTime: null, // 租赁结束日期
        goodsCubage: null, // 货物容积
        expectPrice: null, // 期望价格
        companyId: null, // 公司id
        companyName: null, // 公司名称
        storageLocation: null, // 库房位置
        fireQualification: null, // 消防资质
        fireResistanceRating: null, // 罐区耐火等级
        cargoUrl: null, // 货物照片
        linkMan: null, // 联系人
        telephone: null, // 手机号
        remarks: null, // 备注
        publishStatus: null // 发布状态  1待发布 2已发布
      },
      tankFarmDemandRules: {
        demandName: [{ required: true, validator: this.$character(2, 50, 'check'), trigger: 'blur' }], // 需求名称
        storageType: [{ type: 'array', required: true, message: '请至少选择一个储存类型', trigger: 'change' }], // 储存类型
        leaseStartTime: [{ required: true, message: '请选择租赁开始日期', trigger: 'change' }], // 租赁开始日期
        leaseEndTime: [{ required: true, message: '请选择租赁结束日期', trigger: 'change' }], // 租赁结束日期
        goodsCubage: [{ required: true, validator: goodsCubage }], // 货物容积
        expectPrice: [{ required: true, validator: expectPrice }], // 期望价格
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        fireResistanceRating: [{ required: true, message: '请选择罐区耐火等级', trigger: 'change' }], // 罐区耐火等级
        // cargoUrl: [{ required: true, message: '请输入货物照片', trigger: 'blur' }], // 货物照片
        linkMan: [{ required: true, validator: this.$character(2, 10, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        remarks: [{validator: this.$character(2, 200, 'checkEmpty'), trigger: 'blur' }] // 备注
      }
    }
  },
  computed: {
    getPublishState() {
      return this.state ? 2 : 1
    }
  },
  watch: {
    state: function() {
      this.loadData()
    },
    'queryParams.goodsStartCubage': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.goodsEndCubage)) {
          this.queryParams.goodsEndCubage = 1
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.goodsStartCubage = 1
        } else {
          if (parseFloat(this.queryParams.goodsStartCubage) > parseFloat(this.queryParams.goodsEndCubage)) {
            this.queryParams.goodsEndCubage = this.queryParams.goodsStartCubage
          }
        }
      }
    },
    'queryParams.goodsEndCubage': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.goodsStartCubage)) {
          this.queryParams.goodsStartCubage = 1
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.goodsEndCubage = 1
        }
      }
    },
    'queryParams.demandName': {
      handler: function(val) {
        var reg = this.$character(1, 20, 'regular')
        if (!reg.test(this.queryParams.demandName)) {
          this.queryParams.demandName = ''
        }
      }
    }
  },
  created: function() {
    (async() => {
      await this.getArea()
      await this.getStorageType()
      await this.getFireQualification()
      await this.getFireResistanceRating()
      await this.getTankType()
      this.loadData()
    })()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    // 仓库面积范围
    startChange(val) {
      if (!this.isEmpty(this.queryParams.goodsEndCubage) && this.isEmpty(this.queryParams.goodsStartCubage)) {
        // this.queryParams.goodsStartCubage = 1
      }
    },
    // 仓库面积范围
    endChange(val) {
      if (!this.isEmpty(this.queryParams.goodsStartCubage) && this.isEmpty(this.queryParams.goodsEndCubage)) {
        // this.queryParams.goodsEndCubage = 1
      }
      if (parseFloat(this.queryParams.goodsStartCubage) > parseFloat(this.queryParams.goodsEndCubage)) {
        // this.queryParams.goodsEndCubage = this.queryParams.goodsStartCubage
      }
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    },
    // 罐区需求日期回调
    tankDateSet(date) {
      if (date == null) {
        return false
      }
      this.tankFarmDemand.leaseStartTime = date[0] // 租赁开始日期
      this.tankFarmDemand.leaseEndTime = date[1] // 租赁结束日期
    },
    // 详情展示
    demandInfo(demand) {
      if (demand.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      demand.hidden = !demand.hidden
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.storageType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 消防资质字典
    getFireQualification() {
      this.getLocalStorageUtil('fireQualification').then((fireQualification) => {
        if (fireQualification.length > 0) {
          fireQualification.forEach(res => {
            this.storageType.fireQualification.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireQualification').then(res => {
          const fireQualification = JSON.parse(res.result)
          this.setLocalStorageUtil('fireQualification', fireQualification)
          if (fireQualification.length > 0) {
            fireQualification.forEach(res => {
              this.storageType.fireQualification.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区耐火等级字典
    getFireResistanceRating() {
      this.getLocalStorageUtil('fireResistanceRating').then((fireResistanceRating) => {
        if (fireResistanceRating.length > 0) {
          fireResistanceRating.forEach(res => {
            this.storageType.fireResistanceRating.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireResistanceRating').then(res => {
          const fireResistanceRating = JSON.parse(res.result)
          this.setLocalStorageUtil('fireResistanceRating', fireResistanceRating)
          if (fireResistanceRating.length > 0) {
            fireResistanceRating.forEach(res => {
              this.storageType.fireResistanceRating.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.storageType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.storageType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 邀请企业信息
    inviteClick(res) {
      this.companyManager.data = res
      this.companyManager.visible = true
    },
    // 列表切换监听
    toggleState(state) {
      this.state = state
      this.loadData()
    },
    // 仓库推荐
    popRecommendList(id) {
      console.log(id)
      // 根据id查询出对应列表
      this.warehouseSuggestData = id
      this.recommendManager.visible = true
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
      this.queryParams.storageLocation = null
      this.loadData()
    },
    // 子项选择
    change() {
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 分页监听
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 分页监听
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 批量删除
    batchDel() {
      const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (ids.length > 0) {
        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBatch({ id: ids.join(',') })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: '删除成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: '请选择删除的数据!'
        })
      }
    },
    // 初始化查询
    loadData() {
      this.viewManager.loading = true
      this.queryParams.publishStatus = this.state
      // this.queryParams.userId = '0'
      this.queryParams.myType = true
      this.loadTableData()
      this.allSelection = false
    },
    // 查询列表
    loadTableData() {
      const params = Object.assign(this.pagination, this.queryParams)
      if (params.storageLocation != null && params.storageLocation.length > 0) {
        params.storageLocation = params.storageLocation.join('#')
      }
      findPageDemand(params)
        .then(data => {
          this.data = data.result.rows.map(res => {
            res.hidden = true
            res.selection = false
            return res
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    tankFarmDemandEdit(rulesForm) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const demand = JSON.parse(JSON.stringify(this.tankFarmDemand))
          if (this.tankFarmDemand) {
            if (isValidArray(this.tankFarmDemand.storageLocation)) {
              demand.storageLocation = this.tankFarmDemand.storageLocation.join('#')
            } else {
              demand.storageLocation = ''
            }
            if (this.tankFarmDemand.storageType) {
              demand.storageType = this.tankFarmDemand.storageType.toString()
            } else {
              demand.storageType = ''
            }
            if (this.tankFarmDemand.cargoUrl) {
              demand.cargoUrl = this.tankFarmDemand.cargoUrl.toString()
            } else {
              demand.cargoUrl = ''
            }
          }
          demand.createBy = null
          demand.updateBy = null
          demand.inviteUser = null
          demandEdit(demand).then((result) => {
            // 成功提示
            this.$message({
              offset: 100,
              showClose: true,
              message: '恭喜你，数据修改成功',
              type: 'success'
            })
          }).catch((err) => {
            console.log(err)
          }).finally(() => {
            this.post_flag = false
            this.invitationManager.visible = false
            this.loadData()
          })
        } else {
          // 失败返回数据
          return false
        }
      })
    },
    // 删除
    del(id) {
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (id) {
            demandRemove({ id: id })
              .then(data => {
                this.$message({
                  offset: 100,
                  type: 'success',
                  message: '删除成功!'
                })
                this.loadData()
              })
              .cacth(error => {
                console.error(error)
              })
          }
        })
    },
    // 发布或编辑货源
    edit(demand) {
      const demandData = JSON.parse(JSON.stringify(demand))
      if (demandData) {
        if (demandData.storageType) {
          demandData.storageType = demandData.storageType.split(',')
        } else {
          demandData.storageType = []
        }

        if (demandData.storageLocation) {
          demandData.storageLocation = demandData.storageLocation.split('#')
        } else {
          demandData.storageLocation = []
        }
      }
      // eslint-disable-next-line no-array-constructor
      var date = []
      if (demandData.leaseStartTime) {
        date[0] = demandData.leaseStartTime
      }
      if (demandData.leaseEndTime) {
        date[1] = demandData.leaseEndTime
      }
      this.tankdatepicker = date
      this.tankFarmDemand = demandData
      this.invitationManager.visible = true
    },
    // 单条发布
    publishGetDemand(status, res) {
      // const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (res != null && res.id != null) {
        this.$confirm(`是否确定${status == '2' ? '发布' : '下架'}本条罐区需求信息`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (status == '2') {
            const result = validateData(res)
            if (result && !result.state) {
              this.$message({
                type: 'error',
                message: `数据不完整，请先填写完整再发布!`
              })
              return false
            }
          }

          issueBatch({ id: JSON.stringify([res.id]), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    },
    // 批量发布
    publishdemand(status) {
      const items = this.data.filter(item => item.selection)
      if (items.length > 0) {
        this.$confirm(`是否确定${status == '2' ? '发布' : '下架'}选中的罐区需求信息`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = null
          if (status == '2') {
            ids = items.filter((item, index) => {
              const result = validateData(item)
              if (result && !result.state) {
                this.$message({
                  type: 'error',
                  message: `所选第${parseInt(index) + 1}条数据不完整，请先填写完整再发布!`
                })
                return false
              }
              return true
            }).map(i => i.id)
          } else {
            ids = items.map(i => i.id)
          }

          issueBatch({ id: JSON.stringify(ids), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;

/deep/a{
  text-decoration: none;
}

/deep/.el-select{
  width:100%;
}

/deep/.el-input-group__append, .el-input-group__prepend {
      background-color: #ffffff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #DCDFE6;
      border-left: 0;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
  }

.content-container {
  .demand-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .demand-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
        .demand-condition{
          display: flex;
          flex-wrap: wrap;
          /deep/.el-form-item .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            width: 217px;
            .demand-area{
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #FFF;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #DCDFE6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              width: 100%;
              /deep/.el-form-item__content{
                width: auto;
              }
              &:focus {
                  border-color: #409EFF;
                  outline: 0;
              }
              &:hover {
                  border-color: #C0C4CC;
              }
              .el-form-item{
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;
                /deep/.el-input .el-input__inner {
                    border: 0px solid #DCDFE6;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                }
              }
            }
          }
          .el-form-item{
              display: flex;
              -webkit-box-pack: end;
              -ms-flex-pack: end;
              justify-content: flex-end;
              padding-right: 22px;
              width: 50%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              margin-right: 0 !important;
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .demand-data {
    .demand-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 15.8%;
          }
          &:nth-child(3) {
            flex-basis: 15.8%;
          }
          &:nth-child(4) {
            flex-basis: 15.8%;
          }
          &:nth-child(5) {
            flex-basis: 15.8%;
          }
          &:nth-child(6) {
            flex-basis: 15.8%;
          }
          &:nth-child(7) {
            flex-basis: 15.8%;
          }
        }
      }
    }

    .demand-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(7) {
              flex-basis: 15.8%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .demand-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  .tankDemand-data {
    .demand-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.8%;
          }
          &:nth-child(2) {
            flex-basis: 16.8%;
          }
          &:nth-child(3) {
            flex-basis: 16.8%;
          }
          &:nth-child(4) {
            flex-basis: 16.8%;
          }
          &:nth-child(5) {
            flex-basis: 16.8%;
          }
          // &:nth-child(6) {
          //   flex-basis: 14%;
          // }
          &:nth-child(6) {
            flex-basis: 16%;
          }
        }
      }
    }

    .demand-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(2) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            // &:nth-child(6) {
            //   flex-basis: 13.2%;
            //   overflow: hidden;
            //   text-overflow: ellipsis;
            //   white-space: nowrap;
            //   padding: 5px 0.4%;
            // }
            &:nth-child(6) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .demand-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  .orderDemand-data {
    .demand-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.8%;
          }
          &:nth-child(2) {
            flex-basis: 16.8%;
          }
          &:nth-child(3) {
            flex-basis: 16.8%;
          }
          &:nth-child(4) {
            flex-basis: 16.8%;
          }
          &:nth-child(5) {
            flex-basis: 16.8%;
          }
          &:nth-child(6) {
            flex-basis: 16%;
          }
        }
      }
    }

    .demand-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(2) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .demand-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  // .invitation-data {
  //   .invitation-data-header {
  //     color: $main-color;
  //     font-weight: bold;
  //     background-color: #ffffff;
  //     height: 45px;
  //     margin-bottom: 1rem;
  //     ul {
  //       display: flex;
  //       flex-wrap: nowrap;
  //       height: 100%;
  //       width: calc(100% - 16px);
  //       padding: 8px 8px;
  //       box-sizing: content-box;
  //       li {
  //         overflow: hidden;
  //         white-space: nowrap;
  //         text-overflow: ellipsis;
  //         font-size: 15px;
  //         min-width: 50px;
  //         height: 100%;
  //         line-height: 29px;
  //         text-align: center;
  //         &:nth-child(1) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(2) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(3) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(4) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(5) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(6) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(7) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(8) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(9) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(10) {
  //           flex-basis: 15%;
  //         }
  //       }
  //     }
  //   }
  //   .invitation-data-body {
  //     position: relative;
  //     .data-item {
  //       margin: 8px 0px;
  //       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  //       border: 1px solid #ebeef5;
  //       position: relative;
  //       ul {
  //         display: flex;
  //         flex-wrap: nowrap;
  //         height: 56px;
  //         width: calc(100% - 16px);
  //         padding: 8px 8px;
  //         position: relative;
  //         background-color: white;
  //         li {
  //           overflow: hidden;
  //           white-space: nowrap;
  //           text-overflow: ellipsis;
  //           font-size: 15px;
  //           min-width: 50px;
  //           height: 100%;
  //           line-height: 64px;
  //           text-align: center;
  //           &:nth-child(1) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(2) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(3) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(4) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(5) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(6) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(7) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(8) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(9) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(10) {
  //             flex-basis: 15%;
  //           }
  //         }
  //       }
  //       /deep/ .demand-item-details {
  //         border: 1px solid #ebeef5;
  //         z-index: 0;
  //       }
  //     }
  //   }
  //   .invitation-data-pagination {
  //     width: calc(100% - 32px);
  //     margin-top: 24px;
  //     padding: 16px 0px;
  //     background-color: white;
  //   }
  // }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .demand-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
}
</style>
